import { z } from 'zod';

import { Month } from '@occc/graphql';

export const birthdayMonthsSchema = z.array(z.nativeEnum(Month)).optional();
